import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";
import { FaSignOutAlt } from "react-icons/fa"; // Logout icon
import { gsap } from "gsap";
import client from "../../../src/homeIcons/client.png";
import dash from "../../../src/homeIcons/dashboard.png";
import helpdesk from "../../../src/homeIcons/helpdesk.png";
import quote from "../../../src/homeIcons/quote.png";
import summary from "../../../src/homeIcons/summary.png";
import grohe from "../../../src/clientlogo/index_grohe_logo.jpg";
import americanStandard from "../../../src/clientlogo/index_as_logo.gif";
import lixil from "../../../src/clientlogo/index_lixil_logo.gif";
import WavingHandIcon from "@mui/icons-material/WavingHand";
import img9 from "../../../src/SliderImage/draftHomeIcon.jpg";

const UserHomepage = () => {
  const _code_sign = localStorage.getItem("_code_sign");
  const navigate = useNavigate();
  const clientLogos = [
    { src: grohe, alt: "Grohe" },
    { src: americanStandard, alt: "American Standard" },
    { src: lixil, alt: "Lixil" },
  ];

  // GSAP Animations
  useEffect(() => {
    gsap.fromTo(
      ".icon-link",
      { y: 50, opacity: 0, scale: 0.95 },
      { y: 0, opacity: 1, scale: 1, duration: 0.8, stagger: 0.15, ease: "back.out(1.2)" }
    );

    gsap.fromTo(
      ".client-logo-container",
      { x: -50, opacity: 0 },
      { x: 0, opacity: 1, duration: 1, ease: "power3.out" }
    );

    gsap.fromTo(
      ".user-greeting",
      { x: 50, opacity: 0 },
      { x: 0, opacity: 1, duration: 1, ease: "power3.out", delay: 0.2 }
    );
  }, []);

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem("u_token");
    localStorage.removeItem("role_code");
    navigate("/");
  };

  return (
    <main className="relative w-full h-screen overflow-hidden">
      
      {/* Main Content Area - Bottom Dock Layout */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex items-center justify-center gap-4 sm:gap-6 bg-white/10 backdrop-blur-md border border-white/20 px-8 py-5 rounded-3xl z-10 shadow-2xl">
          
          {/* Dashboard */}
          <Link
            to="/user/dashboard"
            className={`${
              _code_sign === "LIXIL/5087" ? "hidden" : "flex"
            } icon-link group flex-col items-center justify-center gap-2 transition-all duration-300 hover:-translate-y-4`}
          >
            <div className="bg-white/20 p-4 rounded-2xl border border-white/10 shadow-lg group-hover:bg-white/30 group-hover:shadow-[0_8px_32px_rgba(255,255,255,0.25)] transition-all">
              <img src={dash} alt="Dashboard" className="w-10 h-10 drop-shadow-lg transition-transform group-hover:scale-110" />
            </div>
            <span className="text-white text-xs font-semibold tracking-wide drop-shadow-md opacity-80 group-hover:opacity-100 transition-opacity">Dashboard</span>
          </Link>

          {/* Add/View Client */}
          <Link
            to="/user/viewclient"
            className="icon-link group flex flex-col items-center justify-center gap-2 transition-all duration-300 hover:-translate-y-4"
          >
            <div className="bg-white/20 p-4 rounded-2xl border border-white/10 shadow-lg group-hover:bg-white/30 group-hover:shadow-[0_8px_32px_rgba(255,255,255,0.25)] transition-all">
              <img src={client} alt="Add/View Client" className="w-10 h-10 drop-shadow-lg transition-transform group-hover:scale-110" />
            </div>
            <span className="text-white text-xs font-semibold tracking-wide drop-shadow-md opacity-80 group-hover:opacity-100 transition-opacity">Clients</span>
          </Link>

          {/* Create Quotation */}
          <Link
            to="/user/create-quote-fx"
            className="icon-link group flex flex-col items-center justify-center gap-2 transition-all duration-300 hover:-translate-y-4"
          >
            <div className="bg-white/20 p-4 rounded-2xl border border-white/10 shadow-lg group-hover:bg-white/30 group-hover:shadow-[0_8px_32px_rgba(255,255,255,0.25)] transition-all">
              <img src={quote} alt="Create Quotation" className="w-10 h-10 drop-shadow-lg transition-transform group-hover:scale-110" />
            </div>
            <span className="text-white text-xs font-semibold tracking-wide drop-shadow-md opacity-80 group-hover:opacity-100 transition-opacity">New Quote</span>
          </Link>

          {/* Draft */}
          <Link
            to="/user/draft"
            className="icon-link group flex flex-col items-center justify-center gap-2 transition-all duration-300 hover:-translate-y-4"
          >
            <div className="bg-white/20 p-4 rounded-2xl border border-white/10 shadow-lg group-hover:bg-white/30 group-hover:shadow-[0_8px_32px_rgba(255,255,255,0.25)] transition-all">
              <img src={img9} alt="Draft" className="w-10 h-10 drop-shadow-lg transition-transform group-hover:scale-110 rounded-full" />
            </div>
            <span className="text-white text-xs font-semibold tracking-wide drop-shadow-md opacity-80 group-hover:opacity-100 transition-opacity">Drafts</span>
          </Link>

          {/* Summary */}
          <Link
            to="/user/summary"
            className="icon-link group flex flex-col items-center justify-center gap-2 transition-all duration-300 hover:-translate-y-4"
          >
            <div className="bg-white/20 p-4 rounded-2xl border border-white/10 shadow-lg group-hover:bg-white/30 group-hover:shadow-[0_8px_32px_rgba(255,255,255,0.25)] transition-all">
              <img src={summary} alt="Summary" className="w-10 h-10 drop-shadow-lg transition-transform group-hover:scale-110" />
            </div>
            <span className="text-white text-xs font-semibold tracking-wide drop-shadow-md opacity-80 group-hover:opacity-100 transition-opacity">Summary</span>
          </Link>

          {/* Help Desk */}
          <Link
            to="/user/help-desk"
            className="icon-link group flex flex-col items-center justify-center gap-2 transition-all duration-300 hover:-translate-y-4"
          >
            <div className="bg-white/20 p-4 rounded-2xl border border-white/10 shadow-lg group-hover:bg-white/30 group-hover:shadow-[0_8px_32px_rgba(255,255,255,0.25)] transition-all">
              <img src={helpdesk} alt="Help Desk" className="w-10 h-10 drop-shadow-lg transition-transform group-hover:scale-110" />
            </div>
            <span className="text-white text-xs font-semibold tracking-wide drop-shadow-md opacity-80 group-hover:opacity-100 transition-opacity">Help Desk</span>
          </Link>
      </div>

      {/* Top Right Header: Greeting & Logout */}
      <div className="user-greeting absolute top-6 right-6 flex items-center gap-4 z-20">
        <div className="flex items-center gap-2 bg-black/30 backdrop-blur-md border border-white/10 px-4 py-2 rounded-full shadow-lg">
          <span className="text-white text-sm md:text-base tracking-wide font-medium">
            <span className="text-gray-300 font-light">Hey,</span> {localStorage.getItem("user_name")}
          </span>
          <WavingHandIcon className="text-yellow-400 animate-bounce hover:animate-none ml-1" fontSize="small" />
        </div>
        <Tooltip title="Logout" arrow placement="bottom">
          <button 
            onClick={handleLogout}
            className="flex items-center justify-center bg-red-500/80 hover:bg-red-600 text-white p-2.5 rounded-full backdrop-blur-md transition-all shadow-lg hover:scale-105"
          >
            <FaSignOutAlt size={18} />
          </button>
        </Tooltip>
      </div>

      {/* Top Left Header: Client Logos */}
      <div className="client-logo-container absolute top-6 left-6 z-20">
        <div className="flex flex-col bg-black/30 backdrop-blur-md border border-white/10 p-4 rounded-xl shadow-lg">
          <div className="flex items-center gap-4 mb-4">
            {clientLogos.slice(0, 2).map((logo, index) => (
              <div
                key={index}
                className="bg-white/90 p-1.5 rounded-lg shadow-sm"
              >
                <img src={logo.src} alt={logo.alt} className="w-16 h-8 object-contain mix-blend-multiply" />
              </div>
            ))}
          </div>
          
          <div className="w-full h-px bg-white/20 mb-3" />
          
          <div className="flex justify-between items-center gap-3">
            <span className="text-gray-300 text-[10px] tracking-widest font-semibold uppercase">Part of</span>
            <div className="bg-white p-1 rounded">
              <span className="text-orange-600 text-xs font-black tracking-wider uppercase">Lixil</span>
            </div>
          </div>
        </div>
      </div>

    </main>
  );
};

export default UserHomepage;